import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";

// 5 quick taps on the logo (within ~2.5s) reveal the private link to Sean's Studio.
export function useSecretTaps(needed = 5, windowMs = 2500) {
  const [open, setOpen] = useState(false);
  const taps = useRef([]);
  const onTap = () => {
    const now = Date.now();
    taps.current = [...taps.current.filter((t) => now - t < windowMs), now];
    if (taps.current.length >= needed) {
      taps.current = [];
      setOpen(true);
    }
  };
  return { open, setOpen, onTap };
}

export function SecretStudioPopup({ open, onClose }) {
  if (!open) return null;
  const go = () => {
    onClose();
    window.location.hash = "sean";
    window.scrollTo(0, 0);
  };
  return createPortal(
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4"
      style={{ background: "rgba(14,18,48,0.45)", backdropFilter: "blur(6px)" }}
      onClick={onClose}
      data-testid="secret-studio-overlay"
    >
      <div
        className="card animate-pop-in w-full max-w-xs text-center"
        style={{ background: "var(--paper)" }}
        onClick={(e) => e.stopPropagation()}
        data-testid="secret-studio-popup"
      >
        <div className="text-4xl mb-2" aria-hidden>🎬</div>
        <div className="eyebrow text-[var(--red)]">shh… secret door</div>
        <div className="font-display text-2xl text-[var(--ink)] mb-1">Hey Sean!</div>
        <p className="text-sm text-[var(--ink-soft)] mb-4">Ready to post something new to the lab?</p>
        <button onClick={go} className="btn btn-red w-full mb-2" data-testid="secret-studio-open-btn">
          Open Sean's Studio
        </button>
        <button onClick={onClose} className="text-xs font-bold text-[var(--ink-soft)] underline" data-testid="secret-studio-close-btn">
          Not now
        </button>
      </div>
    </div>,
    document.body
  );
}
